import styled from 'styled-components';
import { breakpoints } from './Variables';
import musaSun from '../assets/images/musa-sun.png';
import musaBadge from '../assets/images/musa-badge-gold.png';
import musaStamp from '../assets/images/musa-stamp.png';

export const PageStyles = styled.div`
  min-height: calc(100vh - var(--navHeight));
  background-color: var(--offWhite);

  p a {
    border-bottom: 1px solid var(--black);
  }

  .gatsby-image-wrapper.gif img {
    width: 100%;
  }

  &.journalPage {
    background-color: var(--peach);
    padding-bottom: 0;
  }

  .sections {
    max-width: var(--maxPageWidth);
    margin-left: auto;
    margin-right: auto;

    /* & > *:not(.button):not(.gallery):not(h1):not(.hideaway) { */
    & > .block,
    & > .imageWithAlt {
      padding-left: var(--col1);
      padding-right: var(--col1);
    }
  }

  .gallery {
    width: 100%;
  }

  .gallery {
    margin-bottom: 2rem;
  }

  .slick-slide {
    height: 66vw;
  }

  .legend {
    width: 100%;
    margin-bottom: 1em;
    text-align: center;

    .title {
      text-transform: uppercase;
    }

    &.lower.italic {
      text-transform: none;
      font-style: italic;

      .title {
        text-transform: none;
        font-style: italic;
      }
    }
  }

  .block {
    margin-bottom: 3rem;

    .wrapper {
      column-gap: 2rem;
    }

    h3 {
      margin-bottom: 0.5rem;
      align-self: end;

      // Second header in same block needs space above
      &:nth-of-type(2) {
        margin-top: 1em;
      }
    }

    &.center {
      text-align: center;
    }

    &.spaceAround {
      margin-top: 4rem;
    }

    &.narrow {
      max-width: 30em;
      margin-left: auto;
      margin-right: auto;
    }

    &.large {
      font-size: 1.5em;
    }

    &.noTitleCaps {
      h1,
      h2,
      h3,
      h4 {
        text-transform: none;
      }
    }
  }

  .mb {
    margin-bottom: 2rem;
  }

  .mt {
    margin-top: 2rem;
  }

  .gatsby-image-wrapper.mb,
  .gatsby-image-wrapper:not(.hero).mb {
    margin-bottom: 4rem;
  }

  .pageSection {
    padding-bottom: 3rem;

    &.imageContain {
      img {
        object-fit: contain !important;
      }
    }

    &.imageMaxSize {
      .gatsby-image-wrapper {
        max-height: 33vh;
      }
    }

    &.textHuge {
      font-size: var(--fsQuote);
    }

    @media (min-width: ${breakpoints.breakLg}) {
      padding-bottom: 5rem;
    }
  }

  .gatsby-image-wrapper {
    /* margin-bottom: 4rem; */
  }

  .buttonWrapper {
    text-align: center;

    .button {
      text-transform: lowercase;
      font-size: var(--fsButton);
      background: var(--black);
      color: var(--peach);

      &:hover {
        background: var(--peach);
        color: var(--black);
      }
    }
  }

  .sectionBigTitle {
    h1,
    h2,
    h3 {
      font-size: var(--fsTitle1);
      margin-top: 2rem;
    }
  }

  .block.imageLeft,
  .block.imageRight {
    .gatsby-image-wrapper {
      margin-top: 3rem;
    }
  }

  @media (min-width: ${breakpoints.breakLg}) {
    &:not(.propertyPage):not(.journalPage) {
      padding-bottom: 2rem;
    }

    .block {
      &:not(.mb) {
        margin-bottom: 0;
      }

      &.spaceAround {
        margin-top: 4rem;
        margin-bottom: 2rem;
      }
    }

    .gatsby-image-wrapper:not(.hero) {
      margin-bottom: 0;
    }

    .sectionBigTitleDesktop {
      h1,
      h2,
      h3 {
        font-size: var(--fsTitle1);
        margin-top: 2rem;
      }
    }
  }

  // ===== Specific block layouts ======

  .gallery.fullWidth {
    // TODO: how to make gallery full width here
  }

  // Add space below quote
  .quoteMb {
    blockquote {
      margin-bottom: 4rem;
    }
  }

  // Add space above quote
  .quoteMt {
    blockquote {
      margin-top: 4rem;
    }
  }

  .quoteAlignLeft {
    blockquote {
      text-align: left;
    }
  }

  .block.pageSubheader {
    h2,
    h3 {
      text-align: center;
      margin: 3rem 0 2rem 0;
      font-size: var(--fsTitle2);
      text-transform: none;
    }
  }

  // Add logo background to block
  .block.backgroundLogo {
    background-image: url(${musaBadge});
    background-repeat: no-repeat;
    background-size: 6rem;
    background-position: center bottom;
    padding-bottom: 9rem;
    margin-top: 3rem;

    blockquote {
      text-align: center;
    }
  }

  // Add stamp background to block
  .block.backgroundStamp {
    background-image: url(${musaStamp});
    background-repeat: no-repeat;
    background-position: right top;
    background-size: contain;
    padding-top: 4rem;
    padding-bottom: 1rem;
    margin-bottom: 0;
  }

  // Columns on desktop; background image
  .block.backgroundSun.quoteLeft {
    blockquote {
      background-image: url(${musaSun});
      background-repeat: no-repeat;
      background-size: 30%;
      padding-left: 32%;
      background-position: left center;
    }
    @media (min-width: 500px) and (max-width: ${breakpoints.breakLg}) {
      blockquote {
        background-size: contain;
        padding-left: 0;
      }
    }
    @media (min-width: ${breakpoints.breakLg}) {
      .wrapper {
        display: grid;
        align-items: center;
        grid-template-columns: calc(var(--col4) - 1rem) calc(var(--col8) - 1rem);

        *:not(blockquote) {
          order: 2;
          grid-column-start: 2;
        }

        blockquote {
          order: 1;
          grid-row-start: 1;
          grid-row-end: 4;
        }
      }
    }
  }

  .block.quoteEmptyBackgroundSun {
    blockquote {
      background-image: url(${musaSun});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      height: 100%;
      min-height: 6rem;
      max-height: 11rem;
    }
    @media (min-width: 500px) and (max-width: ${breakpoints.breakLg}) {
    }
    @media (min-width: ${breakpoints.breakLg}) {
    }
  }

  // Columns on desktop
  .block.quoteRight {
    @media (min-width: ${breakpoints.breakLg}) {
      .wrapper {
        display: grid;
        align-items: center;
        grid-template-columns: calc(var(--col8) - 1rem) calc(var(--col4) - 1rem);

        *:not(blockquote) {
          grid-column-start: 1;
        }

        blockquote {
          grid-column-start: 2;
          grid-row-start: 1;
          grid-row-end: 4;
        }
      }
    }
  }

  // Columns on desktop
  .block.quoteLeft {
    @media (min-width: ${breakpoints.breakLg}) {
      .wrapper {
        display: grid;
        align-items: center;
        grid-template-columns: calc(var(--col4) - 1rem) calc(var(--col8) - 1rem);

        *:not(blockquote) {
          grid-column-start: 2;
        }

        blockquote {
          grid-column-start: 1;
          grid-row-start: 1;
          grid-row-end: 4;
        }
      }
    }
  }

  .block.quoteSmall {
    blockquote {
      font-size: 1rem;
      display: block;
    }
  }

  // Columns on desktop (image)
  .block.imageRight {
    @media (min-width: ${breakpoints.breakLg}) {
      .wrapper {
        display: grid;
        align-items: center;
        grid-template-columns: calc(var(--col8) - 1rem) calc(var(--col4) - 1rem);
        grid-template-rows: 1fr;

        *:not(blockquote) {
          grid-column-start: 1;
        }

        .gatsby-image-wrapper {
          grid-column-start: 2;
          grid-row-start: 1;
          grid-row-end: 5;
        }
      }
    }
  }

  .block.imageLeft {
    @media (min-width: ${breakpoints.breakLg}) {
      .wrapper {
        display: grid;
        align-items: center;
        grid-template-columns: calc(var(--col4) - 1rem) calc(var(--col8) - 1rem);
        grid-template-rows: 1fr;

        *:not(.gatsby-image-wrapper) {
          grid-column-start: 2;
        }

        .gatsby-image-wrapper {
          grid-column-start: 1;
          grid-row-start: 1;
          grid-row-end: 4;
        }
      }
    }
  }

  // Fifty-fifty block columns
  .block.fiftyFifty {
    @media (min-width: ${breakpoints.breakLg}) {
      .wrapper {
        grid-template-columns: var(--col6) var(--col6);
      }
    }
  }

  // Columns in page section (image)
  .pageSection.imageLeft {
    @media (min-width: ${breakpoints.breakLg}) {
      display: grid;
      align-items: center;
      grid-template-columns: var(--col4) 1fr;
      grid-template-rows: 1fr;
      column-gap: 3rem;

      &.imageBig {
        grid-template-columns: 1fr var(--col3);
      }

      h3,
      .block {
        grid-column-start: 2;
      }

      .gatsby-image-wrapper {
        grid-column-start: 1;
        grid-row-start: 1;
        grid-row-end: 3;
      }
    }
  }

  // Columns in page section (image)
  .pageSection.imageRight {
    @media (min-width: ${breakpoints.breakLg}) {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr var(--col4);
      grid-template-rows: 1fr;
      column-gap: 3rem;

      &.imageBig {
        grid-template-columns: var(--col3) 1fr;
      }

      h3,
      .block {
        grid-column-start: 1;
      }

      .gatsby-image-wrapper {
        grid-column-start: 2;
        grid-row-start: 1;
        grid-row-end: 3;
      }
    }
  }

  // Columns in page section (image)
  .pageSection.videoRight {
    @media (min-width: ${breakpoints.breakLg}) {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr var(--col4);
      grid-template-rows: 1fr;
      column-gap: 3rem;

      h3,
      .block {
        grid-column-start: 1;
      }

      .vimeo {
        grid-column-start: 2;
        grid-row-start: 1;
        grid-row-end: 3;
      }
    }
  }

  .pageSection.fiftyFifty {
    @media (min-width: ${breakpoints.breakLg}) {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 1fr;
      column-gap: 3rem;
    }
  }

  .block.paragraphColumns2 {
    @media (min-width: ${breakpoints.breakLg}) {
      p {
        columns: 2;
      }
    }
  }

  .block.justified {
    p {
      text-align: justify;
    }
  }

  // Override vertical align
  .pageSection.alignStart {
    @media (min-width: ${breakpoints.breakLg}) {
      align-items: start;
    }
  }

  // Force image to appear last on mobile (sigh...)
  .pageSection.mobileImageLast {
    @media (max-width: ${breakpoints.breakMd}) {
      display: flex;
      flex-direction: column;

      .gatsby-image-wrapper {
        order: 1;
      }
    }
  }
`;
